/**
 * Identyfikatory tabel dla zapisanych konfiguracji widoku (settings-api, TableID).
 * Format: ^[A-Za-z0-9_-]{1,64}$ (bez "#", "/" i spacji).
 * UWAGA: to klucz w bazie - zmiana wartości (także prefiksu poniżej) odcina userów od zapisanych
 * konfiguracji tej tabeli. Nie używaj ResultID (jest tymczasowy).
 * Tabele, których kolumny zależą od danych (element dashboardu, wynik), mają id z kluczem tych danych -
 * każda ma własne widoki.
 */

const TABLE_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

/**
 * Id z prefiksu i klucza; niepoprawne (brak klucza, za długie, niedozwolone znaki) - undefined,
 * czyli tabela bez zapisanych widoków zamiast przyciętego id.
 * @param {string} prefix
 * @param {string} [key]
 * @returns {string|undefined}
 */
function keyedTableId(prefix, key) {
    if (key === undefined || key === null || key === "") return undefined;
    const id = `${prefix}-${key}`;
    return TABLE_ID_PATTERN.test(id) ? id : undefined;
}

export const TableIDs = {
    /**
     * Element dashboardu typu "Tabela".
     * @param {string} itemID ID elementu dashboardu
     */
    dashboardItem: (itemID) => keyedTableId("dashboard-item", itemID),
    /**
     * Szczegóły elementu dashboardu (modal).
     * @param {string} itemID ID elementu dashboardu
     */
    dashboardItemDetails: (itemID) =>
        keyedTableId("dashboard-item-details", itemID),
    /**
     * Szczegóły wyniku (wyniki v2).
     * @param {string} sqlKey klucz zapytania szczegółów, np. "sowInsertionAmount"
     */
    resultsDetails: (sqlKey) => keyedTableId("results-details", sqlKey),
};
